<template>
  <el-dialog title="选择人员" :visible.sync="visible" width="70%" center :close-on-click-modal="false">
    <div class="select-box">
      <div class="box-left fl">
        <el-input v-model="filterText" class="ipt-sty mt15" placeholder="请输入名称"></el-input>
        <p class="fontC-bbb">组织架构</p>
        <el-tree
          class="filter-tree"
          :data="areaData"
          :props="defaultProps"
          :show-checkbox="true"
          :check-strictly="true"
          node-key="guid"
          :filter-node-method="filterNodeDep"
          ref="treeDep"
          @check-change="handleNodeClickPerson"
        >
          <div class="custom-tree-node" slot-scope="{ node, data }">
            <img v-if="data.nodeType == 1" src="../../../assets/images/ico_ora.png" alt="" />
            <img v-else src="../../../assets/images/icon_per.png" alt="" />
            <span>{{ data.name }}{{ data.mobileNo || '' }}</span>
          </div>
        </el-tree>
      </div>
      <div class="box-right fr">
        <p class="fontC-bbb fl">已选{{ departmentList.length }}个成员</p>
        <el-button size="medium" type="danger" @click="delDepartment()" class="fr" style="margin-top: 5px"
          >批量删除
        </el-button>
        <el-table
          :data="departmentList"
          border
          height="280px"
          style="width: 100%"
          @selection-change="handleSelectionChangeDel"
        >
          <el-table-column type="selection" width="55"> </el-table-column>
          <el-table-column header-align="center" align="center" show-overflow-tooltip prop="name" label="名称">
            <template slot-scope="scope">
              {{ scope.row.name }}{{ scope.row.mobileNo }}
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <div slot="footer" class="dialog-footer t-right">
      <el-button plain size="medium" @click="visible = false">取消</el-button>
      <el-button size="medium" type="info" @click="departmentSure()">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props:['tenantGuid'],
  data() {
    return {
      defaultProps: {
        id: 'guid',
        label: 'name',
        children: 'children',
        disabled: this.disabledTreeNode,
      },

      visible: false, //部门人员弹框
      defaultCheckedKeys: [],
      area: [],
      departmentList: [], //选中的部门人员数据
      departmentData: '',
      areaData: [], //人员部门数据
      delList: [],
      personGuidList: [], //选中的人员guid
      filterText: '',
      fullscreenLoading: false,
    };
  },
   watch: {
    filterText(val) {
      this.$refs.treeDep.filter(val);
    },
  },
  created() {
  },
  methods: {
    open(personGuidList) {
      this.personGuidList = personGuidList;
      this.visible = true;
      this.getOrganisation();
      this.$nextTick(() => {
        this.$refs.treeDep.setCheckedKeys(this.personGuidList);
        this.departmentList = this.$refs.treeDep.getCheckedNodes();
      });
    },

    //获取组织
    getOrganisation() {
      let self = this;
      let query = {
        tenantGuid: this.tenantGuid,
        // isTask: 'Y',
      };
      self.api.postJson(`/${serverConfig.msPersonnelService}/organisation/data/get-tree`, query).then(res => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.areaData = res.data.data;
          console.log( self.areaData)
        } else {
          self.$message.error(res.data.msg);
          self.areaData = [];
        }
      });
    },
    //禁用 子级选了父级禁用，父级选了子级禁用
    disabledTreeNode(data, node) {
      let list = this.departmentList;
      if (list.length) {
        let flag = 0;
        let parentGuids = data.parentGuids ? data.parentGuids : [];
        for (let i = 0; i < list.length; i++) {
          let checkedParentGuids = list[i].parentGuids ? list[i].parentGuids : [];
          if (this.isContainOrg(parentGuids, list[i].guid)) {
            flag = 1;
            break;
          } else if (this.isContainOrg(checkedParentGuids, data.guid)) {
            flag = 1;
            break;
          } else {
            flag = 0;
          }
        }
        return flag > 0;
      } else {
        return false;
      }
    },
    isContainOrg(arr, guid) {
      if (!arr.length) return 0;
      let flag = arr.findIndex(one => {
        return one == guid;
      });
      return flag == -1 ? 0 : 1;
    },

    //部门弹框选择
    handleNodeClickPerson(data, checked, node) {
      this.departmentList = this.$refs.treeDep.getCheckedNodes();
    },
    filterNodeDep(value, data) {
      if (!value) return true;
      return data.name.indexOf(value) !== -1;
    },
    //确定选择部门
    departmentSure() {
      this.personGuidList = (this.departmentList || []).map(k => k.guid);
      this.departmentData = this.departmentList;
      if(this.personGuidList.length==0&&this.departmentData.length==0){
        this.$message.error('请选择执行对象！');
        return;
      }
      this.$emit('onSelect', [this.personGuidList, this.departmentData]);
      this.visible = false;
    },
    //删除部门
    delDepartment() {
      let self = this;
      if (self.delList == null || self.delList.length == 0) {
        self.$message.error('请勾选数据！');
        return;
      }
      this.departmentList = this.$refs.treeDep.getCheckedNodes();
      let newArr = [];
      newArr = this.departmentList.filter(item => this.delList.every(one => one.guid !== item.guid));
      this.$refs.treeDep.setCheckedNodes(newArr); //设置树组件的选中
    },

    handleSelectionChangeDel(val) {
      let self = this;
      self.delList = val;
      console.log(val);
    },
  },
};
</script>

<style scoped>
/* 选择人员弹框 */
.select-box {
  overflow: hidden;
  margin: 0 0px 10px 30px;
}

.box-left {
  width: 40%;
  height: 350px;
  padding: 0 20px 20px 20px;
  border: 1px solid #bbb;
  box-sizing: border-box;
  overflow-y: auto;
}

.box-right {
  width: 57%;
  height: 350px;
  padding: 0 10px 20px 20px;
  border: 1px solid #bbb;
  box-sizing: border-box;
}
.select-department {
  color: green;
  text-decoration: underline;
  cursor: pointer;
  margin-left: 0 !important;
}
</style>
